
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/zeta-global",
      function () {
        return require("private-next-pages/destinations/zeta-global.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/zeta-global"])
      });
    }
  